import { render, staticRenderFns } from "./GiftPlan1kEV6.vue?vue&type=template&id=080a1186&"
import script from "./GiftPlan1kEV6.vue?vue&type=script&lang=js&"
export * from "./GiftPlan1kEV6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports